export const ORIGIN = 'GIGAMAISFIBRA'
